


import { Avatar, Fab, List, ListItem, ListItemAvatar, TextField, Typography } from '@mui/material'
import { connect } from 'react-redux'
import React, { useEffect } from 'react';

import { Creature } from '../../redux/entities'
import { seedDefaultCreatures } from '../../redux/defaultCreatures'
import { getCreatures } from '../../redux/store'

import { makeStyles } from '@mui/styles';
import { unwrapResult } from '@reduxjs/toolkit';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    box: {
        border: "1px black",
    }
}));


function CreatureListView(creature, onClick) {


    function onDragStart(e) {
        e.dataTransfer.setData("creature", JSON.stringify(creature));
    }

    return (
        <ListItem key={creature.id} draggable onDragStart={onDragStart} onClick={e => onClick(creature)}>
            <ListItemAvatar>
                <Avatar src={creature.src} alt={creature.name} />
            </ListItemAvatar>
            <Typography variant="body1">{creature.name}</Typography>

        </ListItem>
    );
}

function CreatureList(props) {
    const classes = useStyles();
    const [search, setSearch] = React.useState("");    

    const { creatures, update, remove, fetchAll, seedDefaults, handleImageDrop, onClick } = props;

    useEffect(() => {
        fetchAll().then(() => seedDefaults());
    }, [])

    // console.log("creatures", creatures)

    if (!creatures) return <p>Loading...</p>

    function onDrop(e) {
        handleImageDrop(e).then(result => onClick(result));
    }

    const items = creatures
        .filter(c => c.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()))
        .map(c => CreatureListView(c, onClick));

    const label = creatures.length > 0 ? "Search library..." : "Add minis to your library"

    return (
        <div className={classes.box}
            onDragOver={e => { if (e.dataTransfer.types.includes('text/html') || e.dataTransfer.types.includes('Files')) e.preventDefault() }}
            onDrop={onDrop}
        >
            { (creatures.length > 2) && (<TextField onChange={e => setSearch(e.target.value)} defaultValue={search} label="Search library..."/>) }
            <List >
                {items}
            </List>

        </div>
    );

}

function mapStateToProps(state) {
    const creatures = getCreatures(state);
    // console.log("Creatures loaded", creatures)
    return { creatures: creatures || [] };
};



export default connect(mapStateToProps, {
    update: Creature.actions.updateEntityAsync,
    remove: Creature.actions.removeEntityAsync,
    fetchAll: Creature.actions.fetchAllEntities,
    seedDefaults: seedDefaultCreatures,

})(CreatureList)

